import React from 'react';

import {
  forwardRef,
  ModalOverlay as ChakraModalOverlay,
  useStyleConfig,
} from '@chakra-ui/react';

import { ModalOverlayProps } from './types';

export const ModalOverlay = forwardRef<ModalOverlayProps, 'div'>(
  (props, ref) => {
    const styles = useStyleConfig('ModalOverlay', { ...props });
    return <ChakraModalOverlay ref={ref} sx={styles} {...props} />;
  }
);
